import logger from '../services/logger';
import { Button } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import AuthService from '../services/auth.service'; 
import UserService from '../services/user.service'; 
import AppBadge from '../components/common/AppBadge'; 
import UniverService from '../services/univer.service';
import {useNavigate } from 'react-router-dom';
import { withRouter } from '../common/with-router';
import { calculateTotalCarbonImpact } from './common/C02Data'
import ApplianceServiceInstance from '../services/appliance.service'

const Home = () => {

  const navigate = useNavigate();
  
  const [currentUser, setCurrentUser] = useState(undefined);
  const [badges, setBadges] = useState(true);
  const [univers, setUnivers] = useState(null);
  const [universToShow, setUniversToShow] = useState(null);
  const [impactTotal, setImpactTotal] = useState(0);
  const [productTotal, setProductTotal] = useState(0);
  
  
  const [isLoading, setIsLoading] = useState(true);

  
  /*Contruction chart
  const chartType = 'doughnut';
  const labels = ['PEM', 'GEM'];
  const data = [10, 20];
  // Utiliser les couleurs personnalisées
  const backgroundColors = ['#4FB573', '#E2F3E8']; // Couleurs spécifiées

  // Construire les parties de l'URL
  const quickChartBaseUrl = "https://quickchart.io/chart?v=3&c=";
  const chartConfig = {
    type: chartType,
    data: {
      labels: labels,
      datasets: [{
        data: data,
        backgroundColor: backgroundColors, // Spécifier les couleurs ici
        borderRadius: 20, 
        borderWidth: 0, // Ajouter un espace entre les segments (ajustez cette valeur selon votre besoin)
        borderColor: '#FFFFFF', // Utilisez une couleur blanche pour l'espace entre les segments (ou une autre couleur si vous préférez)
        borderJoinStyle: 'round', // Arrondir les jointures des segments
        spacing: 5, // Espace entre les segments
      }]
    },
    options: {
      cutout: '80%', // Amincir le doughnut (80% d'ouverture)
      plugins: {
        datalabels: {
          display: false // Désactiver les labels sur les segments
        },
        legend: {
          display: false // Désactiver la légende
        }
      },
      elements: {
        arc: {
          borderRadius: 20, // Arrondir les coins des segments
        }
      },
    },
  };

  // Encoder l'objet chartConfig en chaîne JSON pour l'URL
  const chartUrl = quickChartBaseUrl + encodeURIComponent(JSON.stringify(chartConfig));
  */  

  useEffect(() => {
    logger.log("Begin Home");
    const user = AuthService.getCurrentUser();
    logger.log("Le user est ",user);
    
    if (user) {
      logger.log('Hello! setting currentUser ', user.username);
      setCurrentUser(user);
     
      const fetchService = async () => {
        try {
             const badgesresponse = await UserService.getBadge();
            if (badgesresponse.data) {
              setBadges(badgesresponse.data);
            } else {
              setBadges(null);
            }

           
            // Récupérer les univers
            const data = await UniverService.getUniver();  // Récupérer les univers
            
            const universCustom = data.filter(univer => univer.univer_id !== -1);
           
            const universReference = data.filter(univer => univer.univer_id === -1);
           
            const sortedData = [...universCustom, ...universReference]; // Concaténer les deux listes
            
            const firstFourElements = sortedData.slice(0, 5); // Prendre uniquement les 4 premiers éléments
           
            setUnivers(sortedData); // Mettre à jour l'état avec les univers triés
            setUniversToShow(firstFourElements)
            logger.log('univers! ', data);
            setIsLoading(false);

            const response = await ApplianceServiceInstance.getApplianceCountByUser();
            const impactTotal = calculateTotalCarbonImpact(response);
            setImpactTotal(impactTotal);

            let totalAppliances = 0;
            // Récupérer le nombre total d'appareils
            if (response)  totalAppliances=response?.meta?.totalAppliances || 0;
            setProductTotal(totalAppliances);

        } catch (error) {
            logger.log("Erreur lors de la récupération des informarions du user:", error);
        }
      };

      fetchService();  // Appel de la fonction asynchrone pour récupérer les univers
    }
  }, []); // Le tableau de dépendances vide signifie que l'effet s'exécute uniquement au premier rendu



  // Définir la fonction showAllBadges
  const showAllBadges = () => {
    // Logique pour afficher tous les badges
    logger.log('Afficher tous les badges');
  };

  // Définir la fonction showAllBadges
  const gotoSecondLife = () => {
    const tosecond=true;
    navigate(`/inventaire`,{ state: { tosecond } });
  };

  
  const gotoSimu = () => {
    navigate(`/carbotool`);
  };

  const gotoMap = () => {
    navigate(`/carbomap`);
  };

  // Définir la fonction showAllBadges
  const gotoAddProduct = () => {
    navigate(`/new-device`);
  };

  // Définir la fonction showAllBadges
  const gotoMaintenanceProduct = () => {
    const tomaintenance=true;
    navigate(`/productlist`,{ state: { tomaintenance } });
  };

  // Définir la fonction showAllBadges
  const gotoRepair = () => {
    const torepair=true;
    navigate(`/productlist`,{ state: { torepair } });
  };

  // Fonction appelée lorsqu'un univers est cliqué
  const gotoUniver = (currentUniver) => {
    if (currentUniver.univer_id !== -1) {
        // Rediriger vers univerdetail et passer l'objet currentUniver dans l'état
        navigate(`/inventaire/univers/${currentUniver.univer_id}/detail`, { state: { univer: currentUniver } });
      } else {
        navigate(`/inventaire/univers`,{ state: { univers: univers } });
      }
  };

  // Définir la fonction showAllBadges
  const gotoUnivers = () => {
    navigate(`/inventaire/univers`,{ state: { univers: univers } });
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: false,
  };

  if (isLoading) {
    return <div>Chargement en cours...</div>;
  }

  //<ADEMEActorMap className="mt-3 mb-3"></ADEMEActorMap>
  return (
        <div>
              <div className="d-flex row m-0 gap-3">  
                <div className="col-12 col-lg-6 white-background ">
                  <h1 className="mt-3" 
                            style={{ 
                            fontSize:"1.25em",
                            fontWeight: "600",
                            wordWrap: "break-word", // Permet de casser les mots à la fin de la ligne
                            wordBreak: "break-word"
                            }}>Hello {currentUser.firstname} !</h1>
                  
                  <div>
                   
                    <div className='mt-3 mb-2 text-small' style={{ position: 'relative'}}>Prendre soin de tes appareils, c’est un geste simple, utile et durable.</div>
                    <br/>
                    <Slider {...settings} className="" style={{ cursor: 'pointer'}}>
                      <div className="me-4 d-flex flex-column align-items-center green-text text-medium"
                        onClick={() => gotoAddProduct()}> 
                        <div className="card-caroussel green-background mb-2">
                        <img 
                          src={process.env.PUBLIC_URL + '/icons/Heart.svg'} 
                          style={{width: 'auto', height: '2rem', verticalAlign: 'middle' }} alt="profil" />
                        </div>
                        <span>Ajouter</span>
                      </div>
                      <div  
                      className="me-4 d-flex flex-column align-items-center text-medium"
                      onClick={() => gotoMaintenanceProduct()}>
                        <div className="card-caroussel green-background mb-2">
                        <img 
                          src={process.env.PUBLIC_URL + '/icons/Maintenance.svg'} 
                          style={{ width: 'auto', height: '2rem', verticalAlign: 'middle' }} alt="profil" />
                        </div>
                        <span>Entretenir</span>
                      </div>
                      <div className=" me-4 d-flex flex-column align-items-center text-medium"
                          onClick={() => gotoRepair()}>
                        <div className="card-caroussel green-background mb-2">
                        <img 
                          src={process.env.PUBLIC_URL + '/icons/Repair.svg'} 
                          style={{ width: 'auto', height: '2rem', verticalAlign: 'middle' }} alt="profil" />
                        </div>
                        <span>Réparer</span>
                      </div>
                      <div  className="me-4 d-flex flex-column align-items-center text-medium"
                          onClick={() => gotoSecondLife()}> 
                        <div className="card-caroussel green-background mb-2">
                        <img 
                          src={process.env.PUBLIC_URL + '/icons/Secondlife.svg'} 
                          style={{ width: 'auto', height: '2rem', verticalAlign: 'middle' }} alt="profil" />
                        </div>
                        <span>Seconde Vie</span>
                      </div>
                      
                    </Slider>
                  </div>
                </div> 
                <div className="d-md-none mb-4"></div>            
                <div className="col-12 col-lg-6 white-background">
                  <h4 className="mt-3 title col-12 d-flex align-items-end fw-bold mb-2" >Comprendre l'impact</h4>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      position: 'relative',
                      gap: '10px',
                      marginBottom: '20px',
                      fontSize: '1rem',
                      fontWeight: '500',
                    }}
                  >
                    {/* Rectangle vert */}
                    <div
                      className="mt-2 text-small"
                      style={{
                        flex: '70%',
                        padding: '15px',
                        borderRadius: '4px',
                        position: 'relative',
                        backgroundColor: '#E3F4FA'
                      }}
                    > 
                      <p className="col-7 col-md-8 col-lg-7" style={{ margin: 0, lineHeight: '1.8' }}>
                        Tes <span style={{ color: '#2e7d32', fontWeight: '600' }}>{productTotal} appareils </span> représentent environ&nbsp;
                        <span style={{ color: '#2e7d32', fontWeight: '600' }}>{impactTotal.toFixed(0)} kg de CO₂</span> sur leur durée de vie.
                      </p>
                      <p className="col-12 col-md-8 col-lg-8" style={{ margin: 0, lineHeight: '1.6' }}>
                        🌳 Il faudrait planter&nbsp;
                        <span style={{ color: '#2e7d32', fontWeight: '600' }}>{(impactTotal / 35).toFixed(0)} arbres</span> chaque année pour compenser cet impact.
                        ✈️ C’est l’équivalent de&nbsp;
                        <span style={{ color: '#2e7d32', fontWeight: '600' }}>{(impactTotal / 3500).toFixed(0)} vols aller-retour</span> Paris–New York.
                      </p>
                    </div>

                  {/* Cercle gris avec bord blanc */}
                    <div
                      className="circle-container"
                      style={{
                        width: '140px', // Cercle + stroke (100px + 20px * 2)
                        height: '140px',
                        borderRadius: '50%',
                        backgroundColor: 'white', // Couleur du stroke (blanc)
                        position: 'absolute',
                        right: '-1%',
                        top: '15%',
                        transform: 'translateY(-50%)',
                        zIndex: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <div
                        className='light-gray-background'
                        style={{
                          cursor: 'pointer',
                          width: '110px', // Taille réelle du cercle gris
                          height: '110px',
                          borderRadius: '50%',
                          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
                        }}
                        onClick={gotoUnivers}
                        >
                          <p style={{ margin: 0, fontSize : '1.5rem', fontWeight : '500'}}>{productTotal}</p>
                          <p style={{ margin: 0, fontSize : '1rem', fontWeight : '400' }}>Appareils</p>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
              <div className='mt-3 white-background m-0'>
                    <div className=" d-flex mb-1 pt-3" >
                        <h4 className=" title col-6 d-flex align-items-end fw-bold" style={{ color:"white"}}>
                          Mes Univers</h4>
                          <div 
                              className="col-6 d-flex justify-content-end seemore-link align-items-end"
                              style={{ cursor: 'pointer' }} // Le curseur de la souris reste un pointeur cliquable
                              onClick={gotoUnivers}
                            >
                              {/* Contenu de votre lien ici */}
                              Voir plus &rarr;
                            </div>
                      </div>         
                      {/* Affichage de la liste des univers */}
                      {universToShow && <div className="product-container mt-3"> 
                          <div className="d-flex row g-3 m-0">
                              {universToShow.map((univer, index) => (
                                  <div className="col-6 col-md-4 col-lg-4 product-link mb-3" 
                                      key={index}
                                      onClick={() => gotoUniver(univer)}
                                      style={{ cursor: 'pointer' }}>
                                      <div className="text-center"
                                      >
                                          <div className={` mb-1 product-background p-0`}
                                           style={{ backgroundColor: univer.univer_id === -1 ? 'var(--color-light-gray)' : '' }}>
                                              <div className="mb-2" style={{ height: '240px',display: 'flex', justifyContent: 'center', alignItems: 'flex-end' }}>
                                                <img 
                                                    src={univer.image} 
                                                    alt={univer.name || 'Image descriptive manquante'} 
                                                    className="img-fluid d-block mx-auto"
                                                    style={{ width:'100%',height:'100%', maxHeight : '240px',objectFit: 'cover' }}
                                                />
                                              </div>
                                              <div  className="mb-2" style={{ height: '50px',display: 'flex', justifyContent: 'center', alignItems: 'flex-end' }}>
                                                <span className="text-medium" style={{ alignSelf: 'center' }}>{univer.name}</span>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              ))}
                          </div>
                      </div>}
                </div>

                <div className="mt-3 d-flex row m-0 gap-3">  
                    <div className="col-12 col-md-6 col-lg-6 boxShadow" onClick={() => gotoSimu()} style={{ cursor: 'pointer' }}>
                      <div className="p-2 mt-3 mb-3 h-100 d-flex row align-items-center justify-content-center">
                        <p className=" text-center fw-bold">
                        Simulation d'empreinte carbone</p>
                        <p className="text-center text-small px-2">529 kg de CO₂ émis par mon lave-linge pendant toute sa durée de vie
                        </p>
                        <Button
                        className="mt-auto mx-auto d-block mb-3 btn-secondary"
                        onClick={() => gotoSimu()}
                        aria-label="CarboMeter"
                        style={{border:"none" , borderRadius:'12px', color : "white", backgroundColor: 'var(--color-green)'}}
                      >
                        Voir mes impacts
                      </Button>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 boxShadow" onClick={() => gotoMap()} style={{ cursor: 'pointer' }}>
                      <div className=" p-2 mt-3 mb-3 h-100 d-flex row align-items-center justify-content-center">
                        <p className="text-center fw-bold">
                          Carte d'économie circulaire</p>
                          <p className=" align-item-center   text-center text-small px-1">Les réparateurs et les acteurs d'économie circulaire à côté de chez moi 
                          </p>
                          <Button
                            className="mt-auto mx-auto d-block mb-3 btn-secondary"
                            onClick={() => gotoSimu()}
                            aria-label="CarboMeter"
                            style={{borderRadius:'15px', color : "white", backgroundColor: 'var(--color-green)', border: 'none'}}
                          >
                            Voir la carte
                          </Button>
                      </div>
                    </div>
                </div>
              
                <div className='mt-3 white-background p-3'>
                  {badges && badges.length > 0 && (
                    <div> 
                      <div className="d-flex mb-1 pt-3" >
                        <h4 className=" title col-6 d-flex align-items-end fw-bold" >Mes Badges</h4>
                        <div 
                          className="col-6 d-flex justify-content-end seemore-link align-items-end"
                          onClick={showAllBadges}// Ajouter l'événement onClick
                          style={{ cursor: 'pointer' }} // Assurez-vous que le curseur indique un lien cliquable
                        >  
                        Voir plus &rarr; {/* Flèche droite simple */}
                        </div>
                      </div>
                      <div className="d-flex mb-3 mt-3 gap-3"> 
                          {badges.map((badge) => (
                          <div
                           className="col-4 col-md-2 mb-3"
                           key={badge.id}
                           onClick={() => navigate(`/badges/${badge.id}`)}
                           style={{ cursor: 'pointer' }}
                          >
                            <AppBadge image={badge.refbadge.pict} />
                          </div>
                          ))}
                      </div>  
                    </div>
                  )}
                </div>
                
              <br/>
              <br/>

        </div> 
    );
  }


export default withRouter(Home);